import React from "react";
import { Routes, Route } from "react-router";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import CSRGenerator from "./pages/CSRGenerator";
import CSRDecoder from "./pages/CSRDecoder";
import ChainAnalyzer from "./pages/ChainAnalyzer";
import CertificateMatcher from "./pages/CertificateMatcher";
import PFXConverter from "./pages/PFXConverter";
import CAARecordGenerator from "./pages/CAARecordGenerator";
import CAAChecker from "./pages/CAAChecker";
import DCVChecker from "./pages/DCVChecker";
import DNSStampGenerator from "./pages/DNSStampGenerator";
import PasswordGenerator from "./pages/PasswordGenerator";
import CSRPopup from "./pages/CSRPopup";
import IntegrationExamples from "./pages/IntegrationExamples";
import ApiDocs from "./pages/ApiDocs";
import Issuance from "./pages/Issuance";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="csr" element={<CSRGenerator />} />
          <Route path="csr-decoder" element={<CSRDecoder />} />
          <Route path="chain" element={<ChainAnalyzer />} />
          <Route path="match" element={<CertificateMatcher />} />
          <Route path="pfx" element={<PFXConverter />} />
          <Route path="caa" element={<CAARecordGenerator />} />
          <Route path="caa-check" element={<CAAChecker />} />
          <Route path="dcv-checker" element={<DCVChecker />} />
          <Route path="dnsstamp" element={<DNSStampGenerator />} />
          <Route path="password" element={<PasswordGenerator />} />
          <Route path="issuance" element={<Issuance />} />
          <Route path="api-docs" element={<ApiDocs />} />
          <Route path="csr-integration" element={<IntegrationExamples />} />
        </Route>
        <Route path="/csr/popup" element={<CSRPopup />} />
      </Routes>
    </>
  );
}

export default App;
